<template>
  <div>
    <Titulo texto="SISTEMA DE ADMISIÓN ESCOLAR" />

    <div v-if="postulacion_resultado">
      <Cargando :tamanio="150" />
    </div>

    <div v-else>
      <PostulacionValida
        :nombreCompleto="postulante.nombreCompleto"
        :nivel="postulante.curso"
        :fechaPostulacion="fechaPostulacion"
        v-if="postulacion_valida"
      >
        <b-button
          class="btn btn-lg btn-azul-oscuro2 mt-4 gilmer text-uppercase font-weight-bold"
          @click.prevent="descargarPostulacion"
        >
          Descargar Comprobante
          <FontAwesomeIcon icon="download" class="ml-2" />
        </b-button>
      </PostulacionValida>
      <PostulacionInvalida v-else></PostulacionInvalida>
    </div>
  </div>
</template>

<script>
import Cargando from "@/components/generales//modales/Cargando";
import ApiComprobante from "@/service/ApiComprobante";
import Titulo from "@/components/generales/Titulo";
import PostulacionValida from "@/components/generales/postulacion/Valida";
import PostulacionInvalida from "@/components/generales/postulacion/Invalida";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDownload);
export default {
  components: {
    Titulo,
    PostulacionValida,
    PostulacionInvalida,
    FontAwesomeIcon,
    Cargando
  },
  data() {
    return {
      jwt: "",
      postulacion_data: {},
      postulacion_resultado: true,
      postulacion_valida: false,
      postulante: {
        nombreCompleto: "",
        curso: ""
      },
      fechaPostulacion: ""
    };
  },
  beforeMount() {
    this.comprobarJWT();
  },
  methods: {
    comprobarJWT() {
      this.jwt = this.$route.query.postulacion;
      //TODO: Borrar console para produccion
      //console.log("Auth Validar:" + this.jwt);
      if (this.jwt && this.jwt !== "") {
        this.validarComprobante();
      } else {
        if (this.jwt) {
          this.postulacionNoValida();
        } else {
          this.$emit(
            "onError",
            "Ha ocurrido un error en el proceso. Vuelva a intentarlo.",
            "",
            true,
            "Sae",
            "SISTEMA DE ADMISIÒN ESCOLAR"
          );
        }
      }
    },
    async validarComprobante() {
      //let datosPostulacion = await ApiComprobante.validarComprobantePrueba();
      let datosPostulacion = await ApiComprobante.validarComprobante(
        this.jwt,
        this
      );
      if (datosPostulacion) {
        this.postulacionValidada(datosPostulacion);
      } else {
        this.postulacionNoValida();
      }
    },
    descargarPostulacion() {
      this.$router.push({
        name: "DescargarComprobante",
        params: {
          datos: this.postulacion_data
        },
        query: {
          postulacion: this.jwt
        }
      });
    },
    postulacionValidada(postulacion) {
      this.postulacion_resultado = false;
      this.postulacion_valida = true;
      this.postulacion_data = postulacion;
      this.postulante.nombreCompleto = `${postulacion.postulante.nombres} ${
        postulacion.postulante.paterno
      } ${
        postulacion.postulante.materno ? postulacion.postulante.materno : ""
      }`;
      this.postulante.curso = `${postulacion.postulante.glosaNivel}`;
      this.fechaPostulacion = postulacion.fechaModificacion;
    },
    postulacionNoValida() {
      this.postulacion_resultado = false;
      this.postulacion_valida = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Validar.vue